var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BaseFormPaymentMethod", {
        attrs: {
          initialState: _vm.state,
          state: _vm.sync.state,
          form: _vm.sync.$formPayment,
          onReset: _vm.sync.onReset,
          isSubmitted: _vm.isSubmitted
        },
        on: {
          "update:state": function($event) {
            return _vm.$set(_vm.sync, "state", $event)
          },
          "update:form": function($event) {
            return _vm.$set(_vm.sync, "$formPayment", $event)
          },
          "update:onReset": function($event) {
            return _vm.$set(_vm.sync, "onReset", $event)
          },
          "update:on-reset": function($event) {
            return _vm.$set(_vm.sync, "onReset", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("BaseFormAction", {
        attrs: {
          textCancel: _vm.$t("button.cancel"),
          textSubmit: _vm.$t("button.save"),
          isSubmitted: _vm.isSubmitted,
          isHideCloseButton: true
        },
        on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69a32db0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a32db0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/BillingPaymentMethodForm.vue
// module id = null
// module chunks = 